import { Record as ImmutableRecord } from 'immutable';

export const TEXTRACT_MATCH_STATUSES = {
  MATCH: 'match',
  PARTIAL_MATCH: 'partial_match',
  HEADER: 'header',
  DEFAULT: 'default',
  UNKNOWN: 'unknown',
} as const;

type TextractMatchStatus = (typeof TEXTRACT_MATCH_STATUSES)[keyof typeof TEXTRACT_MATCH_STATUSES];

type MatchingColors = { border: string; fill: string; jeFill?: string };

export const MatchingColorsMap: Record<TextractMatchStatus, MatchingColors> = {
  [TEXTRACT_MATCH_STATUSES.MATCH]: {
    border: 'rgba(19, 157, 41, 1)',
    fill: 'rgba(19, 157, 41, 0.12)',
  },
  [TEXTRACT_MATCH_STATUSES.PARTIAL_MATCH]: {
    border: 'rgba(211, 47, 47, 1)',
    fill: 'rgba(211, 47, 47, 0.12)',
  },
  [TEXTRACT_MATCH_STATUSES.DEFAULT]: {
    border: 'rgba(211, 47, 47, 1)',
    fill: 'rgba(105, 105, 105, 0.12)',
    jeFill: 'rgba(255, 255, 255, 0.12)',
  },
  [TEXTRACT_MATCH_STATUSES.HEADER]: {
    border: 'rgba(204, 204, 204, 1)',
    fill: 'rgba(204, 204, 204, 0.12)',
  },
  // A match state this client does not know costs its line the highlight and nothing more.
  [TEXTRACT_MATCH_STATUSES.UNKNOWN]: { border: 'transparent', fill: 'transparent' },
};

export const TwoWayMatchAnchors = {
  rowElementId: (id: string) => `element-${id}`,
  rowMarkerElementId: (id: string) => `element-${id}-child`,
  jeLineElementId: (line: string | number) => `matcher-${line}`,
};

const ArrowStyleRecord = ImmutableRecord({
  strokeColor: 'transparent',
  strokeWidth: 1,
});

const ArrowTargetRecord = ImmutableRecord({
  targetId: null as string | null,
  targetAnchor: 'right',
  sourceAnchor: 'left',
  style: ArrowStyleRecord(),
});

export const ArrowTargetFactory = (targetId: string, color: string, rtl: boolean) => {
  const [targetAnchor, sourceAnchor] = rtl ? ['left', 'right'] : ['right', 'left'];

  return ArrowTargetRecord({
    targetId,
    targetAnchor,
    sourceAnchor,
    style: ArrowStyleRecord({ strokeColor: color }),
  });
};
